export default __webpack_public_path__ + "static/media/directory.b965201e.png";